// extracted by mini-css-extract-plugin
export default {"root":"pGZMn2"};